import { get } from '../../helpers/api';

const fetchPins = async ({ swLng, swLat, neLng, neLat, date }) => {
  const params = new URLSearchParams({ swLng, swLat, neLng, neLat });
  if (date) params.append('date', date);
  const { data } = await get(`/admin/isochrone/pins?${params.toString()}`);
  return data;
};

const fetchPolygons = async (rideIds) => {
  const { data } = await get(`/admin/isochrone/polygons?rideIds=${rideIds.join(',')}`);
  return data;
};

export default { fetchPins, fetchPolygons };
